export function QpuiInputNumberDirective(): ng.IDirective {
    return {
        require: ["^ngModel", "^qpuiInputNumber"],
        scope: {
            ngModel: "=",
            ngModelOptions: "="
        },
        controller: ["$scope", function ($scope) {
            let self = this;

            self.inputValidate = () => {
                return false;
            }

        }],
        controllerAs: "$ctrl",
        template: require("./qpui-input-number.template.html").default,
        link: (scope, element, attributes: qpui.bootstrap.IInputNumberAttribute, ctrls) => {
            if (!ctrls) {
                return;
            }

            let ngModelCtrl = ctrls[0];
            let selfCtrl = ctrls[1];

        }
    }
}